import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Header from './components/Header';
import Master from './components/Master';
import Trailer from './components/Trailer';
import StudyMethod from './components/StudyMethod';
import Memberships from './components/Memberships';
import Financing from "./components/Financing"
import Counseling from './components/Counseling';
import FeaturedResults from './components/FeaturedResults';
import FAQ from './components/FAQ';


function App() {
  return (
    <main className="App">
      <Navbar />
      <Header />
      <Master />
      <Trailer />
      <StudyMethod />
      <Memberships />
      <Financing />
      <Counseling />
      <FeaturedResults />
      <FAQ />
      <Footer />
    </main>
  );
}

export default App;
